<template>
  <el-row style="min-height: 470px;height: 55vh;overflow-y: auto">
    <el-col :lg="15" :md="24" :sm="24" :xs="24" class="leftContent">
      <el-row>
        <el-col :lg="4" :md="3" :sm="4" :xs="4" class="text-right">
          布局：
        </el-col>
        <el-col :lg="20" :md="21" :sm="20" :xs="20">
          <el-radio-group class="radioMargin" v-model="form.layout">
            <el-radio :label="1">曲线合并指标</el-radio>
            <el-radio :label="2">曲线跟随指标</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row class="margin-top-20" v-show="form.layout===1">
        <el-col :lg="4" :md="3" :sm="4" :xs="4" class="text-right">
          名称：
        </el-col>
        <el-col :lg="20" :md="21" :sm="20" :xs="20">
          <el-input size="mini" style="width: 80%" v-model="form.name"></el-input>
        </el-col>
      </el-row>
      <el-row class="margin-top-20">
        <el-col :lg="4" :md="3" :sm="4" :xs="4" class="text-right">
          测点：
        </el-col>
        <el-col :lg="20" :md="21" :sm="20" :xs="20">
          <point-form
            :deviceList='deviceList'
            :index="index"
            :key="index"
            :layout="form.layout"
            :pointList='form.pointList'
            @add="add"
            @deleteIndex="del"
            @uploadData="getData"
            v-for="(item,index) in form.pointList"
          ></point-form>
        </el-col>
      </el-row>
    </el-col>
    <el-col :lg="8" :md="24" :sm="24" :xs="24" class="rightContent">
      <div style="margin: 20px;">效果图:</div>
      <point-view :form="form" @getFormData="getFormData"></point-view>
    </el-col>
  </el-row>
</template>

<script>
import pointForm from "@/views/overview/dialogContent/pointForm";
import pointView from "@/views/overview/dialogContent/pointViewDesign";
import {getDeviceList} from "@/network/device-info";

export default {
  name: "AddTemplate",
  props: ['currentSpaceInfo', 'dialogFlush'],
  components: {pointForm, pointView},
  data() {
    return {
      form: {
        layout: 1, //布局
        name: "", //名称
        pointList: [], //测点列表
      },
      deviceList: [],
    }
  },
  watch: {
    'form.layout': {
      handler() {
        if (this.form.lineData) {
          delete this.form.lineData
        }
        this.form.name = ""
        this.$set(this.form, 'pointList', [])
        this.add()
      }
    },
    dialogFlush() {
      this.form = {
        layout: 1,
        name: "",
        pointList: [],
      }
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.add();
      this.getDeviceList();
    },
    //新增一条测点
    add() {
      if (this.form.pointList.length > 3) {
        this.$message.warning("不能超过4个测点!")
      } else {
        let curveDisplay = true;
        let list = this.form.pointList.filter(item => item.curveDisplay);
        if (this.form.layout === 1 && list.length > 1) {
          curveDisplay = false
        }
        let pointForm = {
          deviceId: null,
          deviceName: '',
          pointId: null,
          pointCode: '',
          pointName: '',
          unit: '',
          curveDisplay: curveDisplay,
          name: '',
        }
        this.form.pointList.push(pointForm);
      }
    },
    //删除一条测点
    del(index) {
      this.form.pointList.splice(index, 1)
      this.$forceUpdate()
    },
    getDeviceList() {
      getDeviceList(this.currentSpaceInfo.id).then(res => {
        if (res.code === 0) {
          this.deviceList = res.data
        }
      })
    },
    //获取测点表单数据
    getData: function (val) {
      let index = val.index;
      this.form.pointList[index] = val.data
    },
    //获取表单数据
    getFormData(data) {
      this.$emit('getPointViewData', data)
    }
  }

}
</script>

<style scoped>
.leftContent {
  height: 100%;
  padding: 20px 20px 20px 0;
  border: 2px dashed rgba(22, 95, 160, .3);
  overflow-x: auto;
}

.rightContent {
  height: 100%;
  margin: 0 10px;
  border: 2px dashed rgba(22, 95, 160, .3);
  overflow-x: auto;
}

.radioMargin {
  margin-top: 5px;
}

@media (max-width: 1635px) {
  .radioMargin {
    margin-top: 3px;
  }
}

@media (max-width: 1200px) {
  .rightContent {
    margin: 10px 0;
  }
}
</style>
